var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrakingTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#004a5d;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2,12.31v-.62c0-.64,.06-1.27,.19-1.89s.31-1.23,.55-1.82c.24-.59,.54-1.15,.9-1.67,.35-.53,.75-1.02,1.2-1.47s.94-.85,1.47-1.2c.53-.35,1.09-.65,1.67-.9,.59-.24,1.19-.43,1.82-.55,.62-.12,1.25-.19,1.89-.19h.62c.64,0,1.27,.06,1.89,.19,.62,.12,1.23,.31,1.82,.55,.59,.24,1.15,.54,1.67,.9s1.02,.75,1.47,1.2c.45,.45,.85,.94,1.2,1.47,.35,.53,.65,1.09,.9,1.67,.24,.59,.43,1.19,.55,1.82,.12,.62,.19,1.25,.19,1.89v.62c0,.64-.06,1.27-.19,1.89-.12,.62-.31,1.23-.55,1.82-.24,.59-.54,1.15-.9,1.67s-.75,1.02-1.2,1.47-.94,.85-1.47,1.2-1.09,.65-1.67,.9c-.59,.24-1.19,.43-1.82,.55-.62,.12-1.25,.19-1.89,.19h-.62c-.64,0-1.27-.06-1.89-.19-.62-.12-1.23-.31-1.82-.55-.59-.24-1.15-.54-1.67-.9-.53-.35-1.02-.75-1.47-1.2-.45-.45-.85-.94-1.2-1.47s-.65-1.09-.9-1.67c-.24-.59-.43-1.19-.55-1.82-.12-.62-.19-1.25-.19-1.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18.16,9.16l-3.31-3.31c-.13-.13-.32-.21-.5-.21h-4.69c-.18,0-.37,.08-.49,.2l-3.31,3.31c-.13,.13-.2,.31-.2,.49v4.68c0,.19,.08,.37,.2,.5l3.31,3.31c.13,.13,.32,.21,.5,.21h4.68c.19,0,.37-.08,.5-.2l3.31-3.31c.13-.13,.2-.31,.2-.5v-4.69c0-.18-.07-.37-.2-.49Zm-1.21,4.89l-2.9,2.9h-4.1l-2.9-2.9v-4.1l2.9-2.9h4.1l2.9,2.9v4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M11.3,14.83c0-.39,.32-.71,.71-.71s.71,.32,.71,.71-.32,.71-.71,.71-.71-.32-.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12,8.47c-.39,0-.71,.32-.71,.71v3.53c0,.39,.32,.71,.71,.71s.71-.32,.71-.71v-3.53c0-.39-.32-.71-.71-.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12,3c4.96,0,9,4.04,9,9s-4.04,9-9,9S3,16.96,3,12,7.04,3,12,3m0-3C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakingTeal);
export default __webpack_public_path__ + "static/media/braking-teal.aac6678563a3f013927920e67137e94d.svg";
export { ForwardRef as ReactComponent };